import Shepherd from 'shepherd.js'

import {vetTourHook} from './check-in-tour.js'
import {reviewTourHook} from './check-in-edit-tour.js'
import {welcomeTourHook} from './welcome-tour.js'

export const WelcomeTour = createWelcomeTour();
export const ReviewTour = createReviewTour();
export const VetTour = createVetTour();

function createWelcomeTour() {
  const tour = makeModalTour();

  return welcomeTourHook(tour);
}

function createVetTour() {
  const tour = makeModalTour();

  return vetTourHook(tour);
}

function createReviewTour() {
  const tour = makeModalTour();

  return reviewTourHook(tour);
}

export function makeModalTour(opts = {}) {
  const defaults = {
    confirmCancel: true,
    confirmCancelMessage: "This won't take long - are you sure?",
    useModalOverlay: true,
    defaultStepOptions: {
      cancelIcon: { enabled: true },
      classes: 'shepherd-theme-arrows',
      arrow: true,
      scrollTo: { behavior: 'smooth', block: 'center' }
    }
  };
  return new Shepherd.Tour({ ...defaults, ...opts });
}

function defaultButtons(isFinal) {
  let nextButton = {}

  if (isFinal) {
    nextButton = {
      action() {
        this.complete();
      },
      text: "Done"
    }
  } else {
    nextButton = {
      action() {
        return this.next();
      },
      text: "Next"
    }
  }

  return [
    {
      action() {
        return this.back();
      },
      classes: 'shepherd-button-secondary',
      text: 'Back'
    },
    nextButton
  ]
}


export function clickElStep(tour, title, text, element, attachOn = "bottom") {
  return {
    title: title,
    text: text,
    attachTo: { element: element, on: attachOn },
    advanceOn: { selector: element, event: "click" },
    highlightClass: "pulse",
    modalOverlayOpeningPadding: 2,
    popperOptions: popperOptions(),
    beforeShowPromise: () => waitForElements({"show": element})
  };
}


export function highlightElStep(tour, title, text, element, attachOn = "bottom", isFinal = false) {
  return {
    title: title,
    text: text,
    attachTo: { element: element, on: attachOn },
    highlightClass: "pointer-events-none", // no click allowed when showing
    modalOverlayOpeningPadding: 2,
    buttons: defaultButtons(isFinal),
    popperOptions: popperOptions(),
    beforeShowPromise: () => waitForElements({"show": element})
  };
}


function conditionsMet(elements) {
  const isPresent = selector =>  {
    let el = document.querySelector(selector) 

    return el !== null && isNotHidden(el);
  };
  const isNullOrPresent = s => s == null || isPresent(s);
  const isNullOrNotPresent = s => s == null || !isPresent(s);

  return isPresent(elements.show) &&
    isNullOrPresent(elements.alsoShow) &&
    isNullOrNotPresent(elements.hide);
}

function isNotHidden(el) {
  return !el.classList.contains("hidden");
};

function waitForElements(elements) {
  const waitTillNextAnimationFrame = () => new Promise(requestAnimationFrame);

  if (conditionsMet(elements)) {
    return Promise.resolve(true);
  } else {
    return waitTillNextAnimationFrame().then(() => waitForElements(elements));
  }
}

function popperOptions() {
  return {
    modifiers: [
      {
        name: "offset",
        options: {
          offset: [0,16]
        }
      }
    ]
  };
}
